window.createTabSection = window.createTabSection || function (initialTab, tabs) {
    return {
        activeTab: initialTab,
        tabs: tabs,
        goTo(direction) {
            const idx = this.tabs.indexOf(this.activeTab);
            const map = {
                next: Math.min(idx + 1, this.tabs.length - 1),
                prev: Math.max(idx - 1, 0),
                first: 0,
                last: this.tabs.length - 1
            };
            this.activeTab = this.tabs[map[direction] ?? idx];
            if (typeof this.$nextTick === 'function') {
                this.$nextTick(() =>
                    document.getElementById('tab-' + this.activeTab)?.focus()
                );
            } else {
                setTimeout(() => document.getElementById('tab-' + this.activeTab)?.focus(), 0);
            }
        }
    };
};